import { EditorEligibilityRule } from './editor-eligibility-rule.model';


export class EditorEligibilityRuleHasRelation extends EditorEligibilityRule {
  className = 'HasRelation';
  operatorName = 'hasRelation';

  relation: string;
  relationCategories: string[];

  constructor(obj?: any) {
    super({
      id: obj?.id ?? null
    });
    this.relation = obj?.relation ?? null;
    this.relationCategories = obj?.relationCategories ?? [];
  }

  static matchesTypeOfLegacySerializedValues(legacyEligibilityRules: any) {
    return legacyEligibilityRules?.args?.[1]?.op === 'fetchUserRelations';
  }

  static getFromLegacySerializedValues(legacyEligibilityRules: any) {
    return new this({
      relation: legacyEligibilityRules.args[0].options.value
    });
  }

  static getFromSerializedValues(serializedValues: any) {
    return new this({
      relation: serializedValues.relation,
      relationCategories: serializedValues.relationCategories
    });
  }

  static getEmptyControlConfig(): { [key: string]: any; } {
    return {
      relation: [{ value: null, disabled: true }],
      relationCategories: [{ value: [], disabled: true }],
    };
  }

  createCopy(): EditorEligibilityRuleHasRelation {
    return new EditorEligibilityRuleHasRelation({
      id: this.id,
      relation: this.relation,
      relationCategories: this.relationCategories
    });
  }

  getRelationName(relationNamesWithCategoryNames: { id: string, name: string, categoryNames: { id: string, name: string }[] }[]): string {
    if (this.relation === null) { return ''; }
    return relationNamesWithCategoryNames
      .find(relationNameWithCategoryNames => relationNameWithCategoryNames.id === this.relation)?.name ?? $localize `Not valid`;
  }

  getRelationCategoriesAsString(
    relationNamesWithCategoryNames: { id: string, name: string, categoryNames: { id: string, name: string }[] }[]
  ): string {
    if (this.relation === null || this.relationCategories.length === 0) { return ''; }
    const categoryNames = relationNamesWithCategoryNames
      .find(relationNameWithCategoryNames => relationNameWithCategoryNames.id === this.relation)?.categoryNames ?? [];
    return this.relationCategories
      .map(relationCategory =>
        categoryNames.find(categoryName => categoryName.id === relationCategory) ?? { id: relationCategory, name: $localize `Not valid` }
      )
      .map(categoryName => categoryName.name)
      .join(', ');
  }

  getControlsConfig(): { [key: string]: any; } {
    return {
      relation: [this.relation],
      relationCategories: [this.relationCategories]
    };
  }

  getSerializedValues(): any {
    return {
      relation: this.relation,
      relationCategories: this.relationCategories
    };
  }
}
